import React, { useState } from "react";
import { LOGO_URL } from "../lib/api";

export const Logo = ({ size = 36, showWordmark = true, src }) => {
  const [failed, setFailed] = useState(false);
  const resolvedSrc = !failed && src ? src : LOGO_URL;
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={resolvedSrc}
        alt="Creative Tribe"
        width={size}
        height={size}
        onError={() => setFailed(true)}
        className="rounded-md object-cover"
        style={{ width: size, height: size }}
      />
      {showWordmark && (
        <div className="leading-none">
          <div className="text-sm font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>
            CREATIVE TRIBE
          </div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">
            Design · Digital · Growth
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
